export default __webpack_public_path__ + "static/src/companys/scb/assets/images/backgrounds/login_bg.png";